// store/actions.js
export default {
	setIsTabChange({
		commit
	}, value) {
		commit('SET_TAB_CHANGE', value);
	}
}